import bonus from './bonus';

export default {bonus}